var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-version1"},[_c('div',{staticClass:"large-screen-wrap",style:(_vm.largeScreenStyle)},[_c('Header'),_c('div',{staticClass:"per-block"},[_c('LeftBlock'),_c('MiddleBlock'),_c('RightBlock')],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }